import { BaseCallback } from './BaseCallback';

class BaseJsBridge extends BaseCallback {
  initialized = false;

  constructor(platform) {
    super(platform);
  }
  sdkAjax({ url, params, method = 'POST', headers = {}, timeout = 10000 }) {
    return new Promise((resolve, reject) => {
      let xhr = new XMLHttpRequest();
      if (!xhr) {
        return reject(
          this.fail({
            msg: '创建请求失败',
          })
        );
      }
      let finalUrl = url;
      method = method.toUpperCase();
      if (params && method === 'GET') {
        if (window.URLSearchParams) {
          finalUrl += '?' + new URLSearchParams(params).toString();
        } else {
          // fallback to manual serialization
          finalUrl +=
            '?' +
            Object.keys(params)
              .map(function (key) {
                return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]);
              })
              .join('&');
        }
      }

      const defaultHeaders = {
        'Content-Type': 'application/json',
      };

      const finalHeaders = Object.assign({}, defaultHeaders, headers);
      xhr.open(method, finalUrl, true);
      Object.keys(finalHeaders).forEach(function (key) {
        xhr.setRequestHeader(key, finalHeaders[key]);
      });
      xhr.onreadystatechange = () => {
        if (xhr.readyState == 4) {
          if (xhr.status == 200) {
            try {
              resolve(
                this.success({
                  msg: '请求成功',
                  data: JSON.parse(xhr.responseText),
                })
              );
            } catch (error) {
              reject(
                this.fail({
                  msg: error,
                  data: xhr.responseText,
                })
              );
            }
          } else {
            return reject(
              this.fail({
                msg: xhr.responseText,
                data: xhr.responseText,
              })
            );
          }
        }
      };
      xhr.timeout = timeout;
      xhr.ontimeout = () => {
        xhr = null;
        return Promise.reject(
          this.fail({
            msg: '请求超时',
          })
        );
      };
      if (method === 'POST') {
        xhr.send(JSON.stringify(params));
      } else {
        xhr.send();
      }
    });
  }
}

export { BaseJsBridge };
